"use strict";

exports.__esModule = true;
exports.WidgetLoadingSpinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _Spinner = require("../../Core/Spinner");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WidgetLoadingSpinner = exports.WidgetLoadingSpinner = function WidgetLoadingSpinner(_ref) {
  var height = _ref.height,
    width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: height,
      width: width
    }
  }, /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null));
};